/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Image_MissingInputs */

const vi_shop_group_image_missing = /** @type {(inputs: Shop_Group_Image_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại này chưa có ảnh`)
};

/**

* @param {Shop_Group_Image_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_image_missing = /** @type {((inputs?: Shop_Group_Image_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Image_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_image_missing(inputs)
});